//todo
//check why sports/hard/30 yields no questions - handler for response 1
//add labels of non default settings to home page
//if custom category is selected remove best/worst category from report

import "../style/settings.css"
import { useState, useContext, useEffect } from "react";
import { AppContext } from "../context/AppContext";
import { useNavigate } from "react-router-dom";

export function Settings() {
    const appContext = useContext(AppContext);
    const [questionAmount, setQuestionAmount] = useState(appContext.settings.amount);
    const [questionDifficulty, setQuestionDifficulty] = useState(appContext.settings.difficulty);
    const [questionCategory, setQuestionCategory] = useState(appContext.settings.category);
    const categories = appContext.categoryLookup;
    const navigate = useNavigate();
    
    const updateNumber = () => {
        setQuestionAmount(document.getElementById("qNumber").value);
        //console.log(questionAmount);
    }

    const updateDifficulty = () => {
        setQuestionDifficulty(document.getElementById("qDifficulty").value);
        //console.log(questionDifficulty);
    }

    const updateCategory = () => {
        setQuestionCategory(document.getElementById("qCategory").value);
        //console.log(questionCategory);
    }

    const applySettings = () => {
        console.log("Apply settings triggered");
        appContext.updateSettings({
            "amount": questionAmount,
            "category": questionCategory,
            "difficulty": questionDifficulty
        });
        navigate("/");
    };

    return(
        <div className="setting">
            <div className="upper">
                <div className="banner">
                    <img 
                        src={require("../media/settings.png")} 
                        alt="settings icon"
                        className="settings-icon"/>
                    <span className="settings-title">SETTINGS</span>
                </div>
            </div>
            <div className="lower">
                <div className="settings-wrapper">
                    <div className="s-wrapper">
                        <span className="setting-text">Number of questions:</span>
                        <select id="qNumber" name="q-no" value={questionAmount} className="q-no" onChange={()=>{updateNumber()}}>
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={30}>30</option>
                            <option value={40}>40</option>
                            <option value={50}>50</option>
                        </select>
                    </div>
                    <hr className="separator"/>
                    <div className="s-wrapper">
                        <span className="setting-text">Question difficulty:</span>
                        <select id="qDifficulty" name="q-no" className="q-no" value={questionDifficulty} onChange={()=>{updateDifficulty()}}>
                            <option value={"any"}>Mixed</option>
                            <option value={"easy"}>Easy</option>
                            <option value={"medium"}>Medium</option>
                            <option value={"hard"}>Hard</option>
                        </select>
                    </div>
                    <hr className="separator"/>
                    <div className="s-wrapper">
                        <span className="setting-text">Question category:</span>
                        <select id = "qCategory" name="q-no" className="q-no" value={questionCategory} onChange={()=>{updateCategory()}}>
                            <option value={0}>Mixed</option>
                            {
                                categories.map(category => <option value={category.id} key={category.id}>{category.name}</option>)
                            }
                        </select>
                    </div>
                </div>
                <button 
                    className="button apply"
                    onClick={applySettings}>
                        APPLY
                </button>
            </div>
        </div>
    );
}